export function calculateDamageAmountAuto({ reason, severity, productPrice }) {
    if (productPrice !== undefined && reason && severity !== undefined) {
        const parsedPrice = parseFloat(productPrice);
        const tenPercent = 0.1 * parsedPrice;
        const thirtyPercent = 0.3 * parsedPrice;
        const fullAmt = parsedPrice + tenPercent;
        let damageAmount = 0;

        if (reason === "Ripped Pages" || reason === "Liquid Damage") {
            if (Number(severity) > 0 && Number(severity) < 4) {
                damageAmount = Math.max(20, Math.min(tenPercent, 50));
            } else {
                damageAmount = Math.max(50, Math.min(thirtyPercent, 300));
            }
        } else if (reason === "Book Lost") {
            if (Number(severity) > 0 && Number(severity) < 4) {
                damageAmount = Math.max(20, Math.min(tenPercent, 50));
            } else {
                damageAmount = fullAmt;
            }
        }

        return damageAmount;
    }
    return 0;
}
